import { Notifications as NotificationsBase } from '@domain-group/suit-theme'

import Notification from './Notification'
import useNotificationsList from './hooks/useNotificationsList'

const Notifications = () => {
  const notificationsPayload = useNotificationsList()

  const {
    callbacks: { performToggleNotifications },
    hasNotifications,
    notifications,
    unseenNotificationsCount,
  } = notificationsPayload

  return (
    <NotificationsBase
      callbacks={{ performToggleNotifications: () => performToggleNotifications() }}
      unseenNotificationsCount={unseenNotificationsCount}
    >
      {hasNotifications && notifications.map(notification => (
        <Notification key={notification.id} notification={notification} />
      ))}
    </NotificationsBase>
  )
}

export default Notifications
